import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQualityControllingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "white",
			children: /* @__PURE__ */ _jsx("g", {
				className: "cls-4",
				children: /* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m19.36,11.92c-.13-.36-.32-.68-.55-.98l-2.22-1.28c-.17-.03-.34-.04-.51-.04-.22,0-.43.02-.64.06l-3.24-1.85L3.23,12.94v.94l9.02,5.21,8.96-5.18v-.94l-1.85-1.05Z"
				})
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "grey",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "m21.42,17.95l-2.2-2.2h0c.16-.2.29-.4.41-.6.01-.02.02-.04.03-.06l1.57-.91c.07-.04.12-.12.12-.2v-.95s0-.03,0-.05c0-.02-.01-.04-.03-.07l-.03-.03s-.03-.03-.05-.04l-1.17-.67v-.04s0,0,0,0c-.45-1.84-2.09-3.12-3.98-3.12-.39,0-.77.05-1.14.16l.02.07-.04-.07h-.02s-2.68-1.54-2.68-1.54c-.07-.04-.16-.04-.23,0L3.03,12.82s-.02.02-.04.03l-.05.06s-.01.03-.02.05c0,.01,0,.03,0,.04v.96c0,.08.04.16.11.2l9.02,5.21s.07.03.12.03.08-.01.12-.03l3.73-2.15s.05,0,.08,0c.96,0,1.9-.34,2.63-.96h.01s2.2,2.19,2.2,2.19c.13.13.36.13.49,0,.07-.07.1-.15.1-.25s-.04-.18-.1-.25Zm-9.48.4v.4L3.38,13.82v-.4l8.56,4.94Zm2.35-8.92c-1.4.69-2.29,2.11-2.29,3.68s.86,2.92,2.19,3.63h0s.05.03.05.03l-2.06,1.19L3.61,13.01l8.5-4.91,2.24,1.29-.07.03h0Zm5.21,3.68c0,.69-.21,1.36-.59,1.92l-2.56,1.48c-.09,0-.17.01-.26.01-1.88,0-3.41-1.53-3.41-3.41s1.53-3.41,3.41-3.41c.16,0,.33.01.48.03l2.19,1.27c.48.61.73,1.34.73,2.11Zm-4.28,4.02l-2.82,1.63v-.4l2.37-1.37.08.03h0c.11.03.22.06.33.09h-.02s.06.02.06.02Zm4.96-4.25h.01s-.02-.12-.02-.12l.49.29-.49.28c0-.07,0-.14,0-.22s0-.15,0-.23Zm-.08,1.06s0-.02,0-.03l.79-.47v.4l-.91.52.02-.05h0c.04-.12.07-.26.1-.38Zm-.07-.04h0Zm-.04-1.75h0Z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "color",
			children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "m17.61,12.08c.08.08.08.21,0,.29l-1.88,1.88s-.09.06-.15.06-.11-.02-.15-.06l-.76-.76c-.08-.08-.08-.21,0-.29.08-.08.21-.08.29,0l.62.62,1.73-1.73c.08-.08.21-.08.29,0Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "m15.58,14.41c-.08,0-.16-.03-.22-.09l-.76-.76c-.12-.12-.12-.32,0-.44.12-.12.32-.12.44,0l.55.55,1.66-1.66c.12-.12.31-.12.44,0h0c.12.12.12.32,0,.44l-1.88,1.88c-.06.06-.14.09-.22.09Zm-.76-1.18s-.06.01-.08.03c-.04.04-.04.11,0,.15l.76.76s.11.04.15,0l1.88-1.88s.04-.11,0-.15c-.04-.04-.11-.04-.15,0l-1.8,1.8-.69-.69s-.05-.03-.08-.03Z"
			})] }), /* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "m17.68,12.01h0c-.12-.12-.32-.12-.44,0l-1.66,1.66-.55-.55c-.12-.12-.32-.12-.44,0-.12.12-.12.31,0,.44l.76.76c.06.06.14.09.22.09s.16-.03.22-.09l1.88-1.88c.12-.12.12-.31,0-.44Z"
			})]
		})
	]
});
export default SvgQualityControllingSm;
